module.exports = __webpack_public_path__ + "static/img/portrait1.ce3a2dbf.webp";